import { Button } from "@mui/material";
import { useSelector } from "react-redux";

function SubmitCancelActions({
  cancelLabel = "Cancel",
  submitLabel = "Submit",
  onCancel,
  buttonClassName,
  cancelButtonProps,
  submitButtonProps,
}) {
  const colorSet = useSelector((state) => state.color);
  const { sx: submitSx, ...restSubmitButtonProps } = submitButtonProps || {};
  const submitColorSx = colorSet?.color
    ? {
        backgroundColor: colorSet.color,
        ":hover": { backgroundColor: colorSet.color },
        color: "white",
      }
    : {};

  return (
    <>
      <Button
        type="button"
        className={buttonClassName}
        variant="contained"
        onClick={onCancel}
        color="error"
        {...cancelButtonProps}
      >
        {cancelLabel}
      </Button>
      <Button
        className={buttonClassName}
        variant="contained"
        type="submit"
        sx={{
          ...submitColorSx,
          ...(submitSx || {}),
        }}
        {...restSubmitButtonProps}
      >
        {submitLabel}
      </Button>
    </>
  );
}

export default SubmitCancelActions;
